import { createAction, props } from '@ngrx/store';

export const HomeActions = {
    EVENT_CMS_MICROSITE: '[microsite] EVENT_CMS_MICROSITE',
    EVENT_LIVE_MICROSITE: '[microsite] EVENT_LIVE_MICROSITE',
    NAVIGATE_PRODUCT_MICROSITE: '[microsite] NAVIGATE_PRODUCT_MICROSITE',
};

export const EventCmsMicrosite = createAction(HomeActions.EVENT_CMS_MICROSITE, props<{ url: string }>());

export const EventLiveMicrosite = createAction(HomeActions.EVENT_LIVE_MICROSITE, props<{ url: string }>());
export const NavigateProductMicrosite = createAction(
    HomeActions.NAVIGATE_PRODUCT_MICROSITE,
    props<{
        productId: string;
        locationPath?: string;
        colorId?: string;
        styleId?: string;
    }>()
);
